<!-- <div class="modal-header">
  <h4 class="modal-title pull-left">Upload File</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-sm-12">
      <div class="form-group">
        <input name="uploadFiles" type="file" (change)="fileChangeEvent($event)" multiple>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv" [disabled]="uploadedFiles?.length == 0" (click)="onConfirm()">Upload</button>
</div>
 -->

<div class="modal-header">
  <h4 class="modal-title pull-left">Upload File</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

 <div class="modal-body upload-file">
  <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="fileDropped($event)"
                 multiple="false" dropZoneLabel="Drag & Drop File">
    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
      <a class="pick-file" (click)="openFileSelector()">
        <div class="d-block">
          <div class="text-center">Drag & Drop File here</div>
          <div class="text-center">Or Pick by Clicking</div>
        </div>
      </a>
    </ng-template>
  </ngx-file-drop>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
</div>
